import { useState } from "react";

import { Icon, Message } from "semantic-ui-react";

import { Input } from "simplydo/react/component-library";

const NumericalText = ({ field, fieldValue = "", updateIdea, isEditing }) => {
  const { minValue, maxValue } = field;
  const [validEntry, setValidEntry] = useState(true);
  if (!isEditing) {
    return <span>{fieldValue} </span>;
  }
  const isNumber = (value) => !fieldValue || !Number.isNaN(parseFloat(value));

  let message: string | null = null;
  if (fieldValue && fieldValue !== "-" && !isNumber(fieldValue)) {
    message = `Enter a number between ${minValue} and ${maxValue}.`;
  } else if (
    minValue !== undefined &&
    (fieldValue as unknown as number) < minValue
  ) {
    message = `Enter a number greater than ${minValue}.`;
  } else if (
    maxValue !== undefined &&
    (fieldValue as unknown as number) > maxValue
  ) {
    message = `Enter a number less than ${maxValue}.`;
  }

  return (
    <div>
      {message && (
        <Message error size="tiny">
          <Icon name="warning sign" />
          {message}
        </Message>
      )}
      <Input
        fluid
        value={fieldValue}
        onChange={(_e, { value }) => {
          //Allow for minus sign to be written first
          if (value === "-" || value === "") {
            updateIdea(value, ["templated", field.id]);
            return;
          }
          //Prevent letters and other invalid inputs
          if (!/^[-]?\d+(\.\d*)?$/.test(value)) {
            return;
          }

          const num = parseFloat(value);
          const isValidMin = !isNumber(minValue) || num >= minValue;
          const isValidMax = !isNumber(maxValue) || num <= maxValue;
          if (isValidMin && isValidMax) {
            setValidEntry(true);
          }

          // Needs to allow setting to string locally if it ends with a dot, to allow for decimal input
          // Should not be saved to the server
          if (value.endsWith(".")) {
            updateIdea(value, ["templated", field.id], true);
          } else {
            updateIdea(num, ["templated", field.id]);
          }
        }}
        onBlur={(e) => {
          const num = parseFloat(e.target.value);
          const isValidMin = !isNumber(minValue) || num >= minValue;
          const isValidMax = !isNumber(maxValue) || num <= maxValue;
          setValidEntry(isNumber(num) && isValidMin && isValidMax);
        }}
        readOnly={!isEditing}
        type="text"
        error={!validEntry}
      />
    </div>
  );
};

export default NumericalText;
